import * as React from 'react';
import { Classes } from '../index';
import classNames from 'classnames';

export type DetailMenuProps = React.PropsWithChildren<{
  className?: string;
}>;

/**
 * DetailMenu - komponenta typicky pro navigaci v rámci stránky.
 */
export const DetailMenu: React.FC<DetailMenuProps> = ({
  children,
  className,
}) => {
  return (
    <div className={classNames(Classes.DETAIL_MENU, className)}>{children}</div>
  );
};
